import { z } from "zod";

export const AuthedUserSchema = z.object({
  id: z.string(),   // HubSpot user ID (numeric string)
  email: z.string().email(),
  name: z.string(),
  hubspotUserId: z.string(),
  // Internal UUID from the users table — stable across auth provider changes.
  // Null until the user has logged in at least once after the users table was created.
  internalUserId: z.string().uuid().nullable(),
  // Sourced from the backend's ADMIN_EMAILS allowlist (see auth-middleware.ts) --
  // never derive this from a hardcoded email check on the frontend.
  isAdmin: z.boolean(),
});

export type AuthedUser = z.infer<typeof AuthedUserSchema>;

// Alias used by frontend to parse GET /v1/auth/me
export const MeResponseSchema = AuthedUserSchema;
export type MeResponse = AuthedUser;
